import { Table } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import SearchInput from '../../../../Components/SearchInput';

const TableUploadExcel = ({ dataSource, onData }) => {
    const data = useMemo(() => (Array.isArray(dataSource) && dataSource.length > 0 ? dataSource : []), [dataSource]);

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectRow, setSelectRow] = useState([]);
    const [searchText, setSearchText] = useState('');

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    const debouncedSearchText = useMemo(() => searchText.toLowerCase(), [searchText]);

    const filteredData = useMemo(() => {
        return data.filter((item) =>
            Object.values(item).some((val) =>
                val && val.toString().toLowerCase().includes(debouncedSearchText)
            )
        );
    }, [debouncedSearchText, data]);

    const columns = useMemo(() => {
        if (data.length === 0) return [];
        return Object.keys(data[0]).map((key) => ({
            title: key.split(/(?=[A-Z])/).join(' '),
            dataIndex: key,
            key,
            width: 150,
            ellipsis: true,
        }));
    }, [data]);

    const rowKey = (record) => record.ID || record.key;

    const rowSelection = {
        type: 'checkbox',
        selectedRowKeys,
        onChange: (newSelectedRowKeys, newSelectedRows) => {
            setSelectedRowKeys(newSelectedRowKeys);
            setSelectRow(newSelectedRows);
            onData(newSelectedRows);
        },
    };

    useEffect(() => {
        if (selectedRowKeys.length === 0 && data.length > 0) {
            onData(data);
        }
    }, [selectedRowKeys, data, onData]);

    const locale = {
        emptyText: 'No data available. Please upload some data.',
    };

    const handleRowClick = (record) => {
        const key = rowKey(record);
        const isSelected = selectedRowKeys.includes(key);

        let newSelectedRowKeys;
        let newSelectedRows;

        if (isSelected) {
            newSelectedRowKeys = selectedRowKeys.filter((k) => k !== key);
            newSelectedRows = selectRow.filter((item) => rowKey(item) !== key);
        } else {
            newSelectedRowKeys = [...selectedRowKeys, key];
            newSelectedRows = [...selectRow, record];
        }

        setSelectedRowKeys(newSelectedRowKeys);
        setSelectRow(newSelectedRows);
        onData(newSelectedRows);
    };

    return (
        <div className="">
            <div className="flex justify-end mb-2">
                <SearchInput value={searchText} onChange={handleSearch} />
            </div>
            <Table
                rowKey={rowKey}
                columns={columns}
                dataSource={filteredData}
                rowSelection={rowSelection}
                onRow={(record) => ({
                    onClick: () => handleRowClick(record),
                    style: { cursor: 'pointer' },
                })}
                pagination={false}
                scroll={{ x: 'max-content', y: 400 }}
                locale={locale}
            />
        </div>
    );
};

export default TableUploadExcel;
